module.exports = __webpack_public_path__ + "img/vertical_7_1_9006.62322f3e.png";